import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { WARM_GREY, PageContextDefinition, PageEntityProvider, LayoutShell, SiteFooterLayout, UiConfig, UiProvider } from '@shapeable/ui';
import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { LayoutStyles, SCOPE_ORANGE, themeOverrides } from '../theme';
import { TickIcon } from '@shapeable/icons';


export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

const TickIconStyles = breakpoints({
  base: css`
    ${theme.FILL(SCOPE_ORANGE)};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,

  TickIcon: styled(TickIcon)`${TickIconStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const config: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    theme: themeOverrides,
    header: {
      // showThemeMode: true,
      variant: 'overlay',
    },
    search: {
      isAvailable: true,
    },
    entity: {
      icons: {
        IndustryGroup: My.TickIcon,
      }
    },

    menuBar: {
    },
    componentProps: {
      PageHeader: {
        themeMode: 'dark',
      },
      MenuItemLink: {
        colors: {
          hover: {
            text: SCOPE_ORANGE,
          }
        }
      },
      MenuItem: {
        colors: {
          bold: SCOPE_ORANGE,
          hover: {
            text: 'strong',
            bold: 'strong',
            background: SCOPE_ORANGE,
          },
          active: {
            text: SCOPE_ORANGE,
          },
        }
      },
    }
  }

  return (
    <UiProvider value={config}>
      <My.Container
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer backgroundColor={WARM_GREY} />
      </My.Container>
    </UiProvider>
  );
  
};

Layout.defaultProps = LayoutDefaultProps;

